<template>
  <div class="dataTables_wrapper form-inline dt-bootstrap" id="example1_wrapper">
    <div class="row">
      <div class="col-sm-6 col-xs-12 text-left">
        <div class="m-b-15" v-if="roleType === 30">
          會員總數： {{ total }} 人
        </div>
        <!--<div class="form-group text-left">-->
          <!--<button class="btn btn-default btn-table-title">匯出表單</button>-->
        <!--</div>-->
        <div class="form-group" v-if="roleType === 99">
          <select class="form-control h-38" v-model="loginType" @change="getMemberList(1)">
            <option value="99">== 登入類型 ==</option>
            <option value="1">手機</option>
            <option value="2">Facebook</option>
            <option value="3">Google</option>
            <option value="4">Line</option>
            <option value="5">街口</option>
            <option value="6">車廠</option>
            <option value="7">品牌既有會員</option>
          </select>
        </div>
      </div>
      <div class="col-sm-6 col-xs-12 text-right">
        <div class="form-group">
          <select class="form-control h-38" v-model="searchSelect">
            <option value="1" v-if="roleType === 99">信箱</option>
            <option value="2">手機</option>
            <option value="3" v-if="roleType === 99">暱稱</option>
            <option value="4" v-if="roleType === 99">會員ID</option>
            <option value="5">編號</option>
          </select>
        </div>
        <div class="form-group search-bar">
          <div class="input-group">
            <input class="form-control" type="text" v-model="search.result">
            <span class="input-group-addon c-pointer" @click="clickSearch()"><i class="fa fa-search"></i></span>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-12 table-responsive p-x-0">
        <table aria-describedby="example1_info" role="grid" id="example1" class="table table-bordered table-striped dataTable">
          <thead>
          <tr role="row">
            <th class="vertical-m" colspan="1" rowspan="1">#</th>
            <th class="vertical-m" colspan="1" rowspan="1">編號</th>
            <th class="vertical-m" colspan="1" rowspan="1" v-if="roleType === 99">ID</th>
            <th class="vertical-m" colspan="1" rowspan="1" v-if="hasExistingMember &&(roleType === 30 || roleType === 10)">品牌既有會員 ID</th>
            <th class="vertical-m" colspan="1" rowspan="1">暱稱</th>
            <th class="vertical-m" colspan="1" rowspan="1">手機</th>
            <th class="vertical-m" colspan="1" rowspan="1" style="min-width: 72px;" v-if="roleType === 99">登入類型</th>
            <th class="vertical-m" colspan="1" rowspan="1" v-if="roleType === 99">手機認證</th>
            <th class="vertical-m" colspan="1" rowspan="1" v-if="roleType === 99">開通</th>
            <th class="vertical-m" colspan="1" rowspan="1" v-if="roleType === 99">權限</th>
            <th class="vertical-m" colspan="1" rowspan="1" v-if="roleType !== 10">性別</th>
            <th class="vertical-m" colspan="1" rowspan="1" v-if="roleType === 99">信箱</th>
            <th class="vertical-m" colspan="1" rowspan="1" v-if="roleType !== 10">生日</th>
            <th class="vertical-m" colspan="1" rowspan="1" v-if="roleType === 99">建立時間</th>
            <th class="vertical-m" colspan="1" rowspan="1" v-if="roleType === 99">整合狀態</th>
            <th class="vertical-m" colspan="1" rowspan="1">是否為訪客</th>
            <th class="vertical-m" colspan="1" rowspan="1">訂單記錄</th>
            <th class="vertical-m" colspan="1" rowspan="1" v-if="roleType === 99">整合紀錄</th>
            <th class="vertical-m" colspan="1" rowspan="1" v-if="roleType === 99"></th>
          </tr>
          </thead>
          <tbody v-if="isLoading">
            <tr>
              <td colspan="12" class="text-center">資料讀取中......</td>
            </tr>
          </tbody>
          <tbody v-else-if="memberList.length === 0" >
            <tr style="background-color: white">
              <td rowspan="1" colspan="18" style="text-align: center; padding-bottom: 80px; padding-top:80px;">
                <img src="/static/img/noMatchdata.svg" style="max-width: 148px;" class="center-block logo">
                <span style="margin-bottom: 80px; color: #696969;">沒有符合的資料</span>
              </td>
            </tr>
          </tbody>
          <tbody v-else-if="memberList.length > 0">
          <tr class="even" role="row" v-for="(member, index) in memberList">
            <td>
              {{index + 1}}
            </td>
            <!-- 編號 -->
            <td>
              <!-- Admin 有點擊 ID 前往檢視會員資料的連結功能 -->
              <router-link :to="{path: 'memberInfo/' + member.shopper_id}" target="_blank" v-if="roleType === 99">{{member.user_no}}</router-link>
              <!-- Brand、Store 沒有點擊 ID 前往檢視會員資料的連結功能 -->
              <span v-if="roleType === 30 || roleType === 10">{{member.user_no}}</span>
            </td>
            <!-- ID -->
            <td v-if="roleType === 99">{{member.shopper_id}}</td>

            <!-- 品牌既有會員 ID | 針對有執行既有會員導入的品牌 Brand、Store 權限會於列表顯示 -->
            <td v-if="hasExistingMember && (roleType === 30 || roleType === 10)">
              {{ member.vendor_custom_user_no }}
            </td>
            <!-- End 品牌既有會員 ID | 針對有執行既有會員導入的品牌 Brand、Store 權限會於列表顯示 -->

            <td>{{member.nickname}}<span v-if="member.last_name || member.first_name"> ({{member.last_name}}{{member.first_name}})</span></td>
            <td>{{member.phone}}</td>
            <td v-if="roleType === 99">
              <!-- 自建帳號 -->
              <span v-if="member.create_account_type == 1"><img class="img-login-type img-round" src="/static/img/icon/phone-v2.svg"></span>
              <!-- FB帳號 -->
              <span v-if="member.create_account_type == 2"><img class="img-login-type img-round" src="/static/img/icon/fb.png"></span>
              <!-- Google帳號 -->
              <span v-if="member.create_account_type == 3"><img class="img-login-type img-round" src="/static/img/icon/google.png"></span>
              <!-- LINE帳號 -->
              <span v-if="member.create_account_type == 4">
                <img class="img-login-type img-round" style="margin-right: 8px;" src="/static/img/icon/line.png">
              </span>
              <span v-if="member.create_account_owner_type == 2 && member.create_account_type == 4">
                ({{member.create_account_owner_brand_name}})
              </span>
              <span v-else-if="member.create_account_owner_type == 1 && member.create_account_type == 4">
                (你訂)
              </span>
              <!-- 街口 -->
              <span v-if="member.create_account_type == 5"><img class="img-login-type img-round" src="/static/img/icon/jkos.svg"></span>
              <!-- 車廠 -->
              <span v-if="member.create_account_type == 6"><img class="img-login-type img-round" src="/static/img/icon/car.png"></span>
              <!-- 品牌既有會員 -->
              <span v-if="member.create_account_type == 7">
                <img class="img-login-type img-round" src="/static/img/icon/existing-member.png" alt="品牌既有會員">
                <span>{{ member.create_account_owner_brand_name }}</span>
              </span>
            </td>
            <td v-if="roleType === 99">
              <span v-if="member.is_phone_valid" class="label label-success">通過</span>
              <span v-if="!member.is_phone_valid"  class="label label-danger">未通過</span>
            </td>
            <td v-if="roleType === 99">
              <span v-if="member.is_active" class="label label-success">啟動</span>
              <span v-if="!member.is_active"  class="label label-danger">未啟動</span>
            </td>
            <td v-if="roleType === 99">
              <span v-if="!member.is_suspend" class="label label-success">正常</span>
              <span v-if="member.is_suspend"  class="label label-danger">停權</span>
            </td>
            <td v-if="roleType !== 10">
              <span v-if="member.sex == 1" class="text-blue"><i class="fa fa-male" aria-hidden="true"></i></span>
              <span v-if="member.sex == 2"  class="text-red"><i class="fa fa-female" aria-hidden="true"></i></span>
            </td>
            <td v-if="roleType === 99">{{member.email}}</td>
            <td v-if="roleType !== 10">{{member.birth}}</td>
            <td v-if="roleType === 99">{{member.create_time}}</td>
            <td v-if="roleType === 99">
              <span 
                v-if="member.is_integrated === 1 && member.integrated_shopper_list.length > 0" 
                class="tag-default text-white bg-blue"
              >
                主帳號
              </span>
              <span 
                v-else-if="member.is_integrated === 1 && member.integrated_shopper_list.length === 0" 
                class="tag-default text-white bg-orange"
              >
                副帳號
              </span>
              <span 
                v-else 
                class="tag-default text-white bg-gray-2"
              >
                尚未整合
              </span>
            </td>
            <td>
              <span>{{ member.is_guest ? '是' : '否' }}</span>
            </td>
            <td>
              <router-link :to="{path: '/memberOrderTable/' + member.shopper_id}" target="_blank">
                <button class="btn btn-default"><i class="fa fa-list-alt" aria-hidden="true"></i></button>
              </router-link>
            </td>
            <td v-if="roleType === 99 && member.integrated_shopper_list">
              <!-- 主帳號 -->
              <router-link
                v-if="member.integrated_shopper_list.length > 0"
                :to="{ path: '/upgradememberInfo/' + member.shopper_id }"
                target="_blank"
              >
                <button class="btn btn-default">
                  <img
                    class="full-whdth"
                    src="../../../../assets/icon/clipboard-list.svg"
                    alt="point_icon"
                  />
                </button>
              </router-link>
              <!-- 被整合的副帳號 -->
              <router-link
                v-else-if="member.is_integrated && member.main_shopper_id"
                :to="{ path: '/upgradememberInfo/' + member.main_shopper_id }"
                target="_blank"
              >
                <button class="btn btn-default">
                  <img
                    class="full-whdth"
                    src="../../../../assets/icon/clipboard-list.svg"
                    alt="point_icon"
                  />
                </button>
              </router-link>
            </td>
            <td v-if="roleType === 99">
              <router-link :to="{path: '/upMember/' + member.shopper_id}">
                <button class="btn btn-default"><i class="fa fa-pencil" aria-hidden="true"></i></button>
              </router-link>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
      <div v-if="memberList.length" class="col-xs-12 text-center">
        <ul class="pagination">
          <li class="paginate_button" @click="clickEnd('pre')">
            <a class="c-pointer"><i class="fa fa-step-backward" aria-hidden="true"></i></a>
          </li>
          <li class="paginate_button"  @click="clickGroup('left')">
            <a class="c-pointer"><i class="fa fa-backward" aria-hidden="true"></i></a>
          </li>
          <li class="paginate_button" v-for="index in pageAmount" :class="{active: isActive(index)}" @click="clickPage(index)" v-if="pageShow(index)">
            <a class="c-pointer">{{index}}</a>
          </li>
          <li class="paginate_button disabled" v-for="dis in (groupAmount - Math.ceil(pageAmount % 10))" v-if="pageGroup === Math.ceil(pageAmount / groupAmount)">
            <a class="c-pointer">&nbsp;&nbsp;</a>
          </li>
          <li class="paginate_button" @click="clickGroup('right')">
            <a class="c-pointer"><i class="fa fa-forward" aria-hidden="true"></i></a>
          </li>
          <li class="paginate_button" @click="clickEnd('forward')">
            <a class="c-pointer"><i class="fa fa-step-forward" aria-hidden="true"></i></a>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<style lang="sass">
.img-login-type
  height: 18px
</style>
<script>
import { mapGetters } from 'vuex'
export default{
  data () {
    return {
      roleType: 99,
      memberList: [],
      count: 20,
      total: 0,
      tableIndex: 1,
      pageGroup: 1,
      groupAmount: 10,
      show: {
        brand: false,
        menu: false,
        schedule: false
      },
      loginType: 99,
      search: {
        result: ''
      },
      searchSelect: 1,
      brandId: '',
      storeId: '',
      isLoading: true,
      hasExistingMember: 0
    }
  },
  methods: {
    clickPage (index) {
      this.tableIndex = index
      this.getList(index)
    },
    clickGroup (type) {
      if (type === 'left' && this.pageGroup !== 1) {
        this.pageGroup = this.pageGroup - 1
        this.tableIndex = this.groupAmount * this.pageGroup
        this.clickPage(this.tableIndex)
      } else if (type === 'right' && this.pageGroup !== Math.ceil(this.pageAmount / this.groupAmount)) {
        this.pageGroup = this.pageGroup + 1
        this.tableIndex = this.groupAmount * (this.pageGroup - 1) + 1
        this.clickPage(this.tableIndex)
      }
    },
    clickEnd (type) {
      if (type === 'pre') {
        this.clickPage(1)
        this.pageGroup = 1
      } else if (type === 'forward') {
        if (this.pageAmount) this.clickPage(this.pageAmount)
        else this.clickPage(1)
        this.pageGroup = Math.ceil(this.pageAmount / this.groupAmount)
      }
    },
    isActive (index) {
      if (this.tableIndex === index) return true
      else return false
    },
    getMemberList (index) {
      this.isLoading = true
      var self = this
      if (index) this.tableIndex = index
      var data = {
        page: this.tableIndex,
        size: this.count,
        login_type: parseInt(this.loginType, 10),
        search: this.search.result
      }
      let searchSelect = parseInt(this.searchSelect, 10)
      var url = '/shopper/list' + '?page=' + data.page + '&size=' + data.size
      if (searchSelect === 3 && data.search) url = url + '&nickname=' + data.search
      else if (searchSelect === 2 && data.search) url = url + '&phone=' + data.search
      else if (searchSelect === 4 && data.search) url = url + '&shopper_id=' + data.search
      else if (searchSelect === 1 && data.search) url = url + '&email=' + data.search
      else if (searchSelect === 5 && data.search) url = url + '&user_no=' + data.search
      if (data.login_type !== 99) url = url + '&login_type=' + data.login_type
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          self.isLoading = false
          self.memberList = response.data.shopper_list
          self.total = response.data.total
        }
      })
      this.$router.push({ query: {
        ...this.$route.query,
        login_type: parseInt(this.loginType, 10)
      }})
    },
    getBrandMemberList (index) {
      this.isLoading = true
      var self = this
      if (index) this.tableIndex = index
      var data = {
        page: this.tableIndex,
        size: this.count,
        search: this.search.result
      }
      let searchSelect = parseInt(this.searchSelect, 10)
      var url = '/brand/' + this.brandId + '/shopperList' + '?page=' + data.page + '&size=' + data.size
      if (searchSelect === 5 && data.search) url = url + '&user_no=' + data.search
      else if (searchSelect === 2 && data.search) url = url + '&phone=' + data.search
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          self.memberList = response.data.shopper_list
          self.total = response.data.list_total
          self.isLoading = false
          self.hasExistingMember = response.data.has_existing_member
        }
      })
    },
    getStoreMemberList (index) {
      this.isLoading = true
      var self = this
      if (index) this.tableIndex = index
      var data = {
        page: this.tableIndex,
        size: this.count,
        search: this.search.result
      }
      let searchSelect = parseInt(this.searchSelect, 10)
      var url = '/store/' + this.storeId + '/shopperList' + '?page=' + data.page + '&size=' + data.size
      if (searchSelect === 5 && data.search) url = url + '&user_no=' + data.search
      else if (searchSelect === 2 && data.search) url = url + '&phone=' + data.search
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          self.memberList = response.data.shopper_list
          self.total = response.data.list_total
          self.isLoading = false
        }
      })
    },
    getBrand () {
      var self = this
      var url = 'brand/listBrief'
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          if (response.data.list.length) {
            self.brandId = response.data.list[0].brand_id
            if (self.roleType === 30) self.getBrandMemberList(1)
            else self.getStore()
          }
        }
      })
    },
    getStore () {
      console.log('getStore | MemberTableTemp')
      var self = this
      var url = '/brand/' + this.brandId + '/storeListBrief'
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          if (response.data.list.length) {
            self.storeId = response.data.list[0].store_id
            self.getStoreMemberList(1)
          }
        }
      })
    },
    clickSearch () {
      if (this.roleType === 99) {
        this.getMemberList(1)
      } else if (this.roleType === 30 || this.roleType === 10) {
        this.getBrand(1)
      }
    },
    pageShow (index) {
      var num = index / this.groupAmount
      if (this.pageGroup - 1 < num && num <= this.pageGroup) return true
      else return false
    },
    getList (index) {
      if (this.roleType === 99) this.getMemberList(index)
      else if (this.roleType === 30) this.getBrandMemberList(index)
      else if (this.roleType === 10) this.getStoreMemberList(index)
    }
  },
  created () {
    if (this.$route.name === 'brandTable') this.show.brand = true
    else if (this.$route.name === 'menuTable') this.show.menu = true
    else if (this.$route.name === 'scheduleTable') this.show.schedule = true
    this.roleType = parseInt(this.getRoleType, 10)
    if (this.$route.query.login_type) this.loginType = parseInt(this.$route.query.login_type, 10) // 登入類型，預設為 99
    if (this.roleType === 99) this.getMemberList()
    else if (this.roleType === 30 || this.roleType === 10) {
      this.getBrand()
      this.searchSelect = 2
    }
  },
  computed: {
    ...mapGetters(['getRoleType']),
    getDataH () {
      return this.$parent.getDataH
    },
    pageAmount () {
      if (Math.ceil(this.total / this.count) > 1000) {
        return 1000
      } else {
        return Math.ceil(this.total / this.count)
      }
    }
  }
}
</script>
<style lang="sass">
.img-round
  border-radius: 4px
.vertical-m
  vertical-align: middle!important
.tag-default
  padding: 2px 6px
  white-space: nowrap
  border-radius: 4px;
</style>



// WEBPACK FOOTER //
// MemberTableTemp.vue?3b2a6974